export const AggregationGroupsScheme = {
    mainData_firstRegistrationYear: 'HISTOGRAM',
    price_currentSalesPrice: 'HISTOGRAM',
    mainData_mileage: 'HISTOGRAM',
    engineData_powerPS: 'HISTOGRAM',
    engineData_powerKW: 'HISTOGRAM',
    selector_fuel_other: 'FUEL',
    selector_fuel_petrol: 'FUEL',
    selector_fuel_diesel: 'FUEL',
    selector_fuel_carGas: 'FUEL',
    selector_fuel_naturalGas: 'FUEL',
    selector_fuel_gas: 'FUEL',
    selector_fuel_electrical: 'FUEL',
    selector_fuel_hybridElectricalPetrol: 'FUEL',
    selector_fuel_hybridElectricalDiesel: 'FUEL',
    selector_fuel_hydrogen: 'FUEL',
    selector_fuel_ethanol: 'FUEL',
    selector_driveType_other: 'DRIVE_TYPE',
    selector_driveType_frontWheelDrive: 'DRIVE_TYPE',
    selector_driveType_rearWheelDrive: 'DRIVE_TYPE',
    selector_driveType_allWheelDrive: 'DRIVE_TYPE',
    selector_gearbox_other: 'TRANSMISSION',
    selector_gearbox_automatic: 'TRANSMISSION',
    selector_gearbox_manualShift: 'TRANSMISSION',
    selector_gearbox_semiAutomatic: 'TRANSMISSION',
    exterior_metallic: 'METALLIC',
    engineData_startStopSystem: 'HIGHLIGHTS',
    driveSuspension_driveType: 'HIGHLIGHTS',
    interior_interiorType: 'HIGHLIGHTS',
    assistants_abs: 'HIGHLIGHTS',
    assistants_esp: 'HIGHLIGHTS',
    assistants_headUpDisplay: 'HIGHLIGHTS',
    assistants_collisionAvoidance: 'HIGHLIGHTS',
    assistants_parkingAssistants: 'HIGHLIGHTS',
    assistants_automaticRainSensor: 'HIGHLIGHTS',
    assistants_cruiseControl: 'HIGHLIGHTS',
    assistants_trafficSignRecognition: 'HIGHLIGHTS',
    heatingCooling_climatisation: 'HIGHLIGHTS',
    heatingCooling_auxiliaryHeating: 'HIGHLIGHTS',
    multimedia_bluetooth: 'HIGHLIGHTS',
    multimedia_handsFreePhoneSystem: 'HIGHLIGHTS',
    multimedia_navigationSystem: 'HIGHLIGHTS',
    seats_electricHeated: 'HIGHLIGHTS',
    airbags_airbag: 'HIGHLIGHTS',
    wheel_multifunctionalWheel: 'HIGHLIGHTS',
    lights_laserHeadlights: 'HIGHLIGHTS',
    lights_ledHeadlights: 'HIGHLIGHTS',
    lights_lightSensor: 'HIGHLIGHTS',
    lights_xenonHeadlights: 'HIGHLIGHTS',
    window_panoramicGlassRoof: 'HIGHLIGHTS',
    trailerCoupling_trailerCouplingRemovable: 'HIGHLIGHTS',
    trailerCoupling_trailerCouplingFix: 'HIGHLIGHTS',
    trailerCoupling_trailerCouplingRotatable: 'HIGHLIGHTS',
    search_parkingAssistants: 'HIGHLIGHTS',
    search_seatHeating: 'HIGHLIGHTS',
    search_trailerHitch: 'HIGHLIGHTS',
    assistants_emergencyAssistant: 'HIGHLIGHTS',
    search_noIncandescentLight: 'HIGHLIGHTS',
    selector_tiresRims_alloy: 'HIGHLIGHTS',
    // STATE_OPTIONS
    selector_usageType_demonstrationCar: 'STATE_OPTIONS',
    selector_usageType_employeesCar: 'STATE_OPTIONS',
    selector_usageType_preRegistration: 'STATE_OPTIONS',
    // STATE_OPTIONS_NEW
    offer_newHuAu: 'STATE_OPTIONS_NEW',
    careService_fullServiceHistory: 'STATE_OPTIONS_NEW',
    offer_warranty: 'STATE_OPTIONS_NEW',
    mainData_nonSmokerVehicle: 'STATE_OPTIONS_NEW',
    // VEHICLE_CONDITION
    selector_condition_new: 'VEHICLE_CONDITION',
    selector_condition_used: 'VEHICLE_CONDITION',
    // Vehicle Type 
    selector_category_combi: 'BODY_TYPE',
    selector_category_sedan: 'BODY_TYPE',
    selector_category_compact: 'BODY_TYPE',
    selector_category_convertible: 'BODY_TYPE',
    selector_category_coupe: 'BODY_TYPE',
    selector_category_minibus: 'BODY_TYPE',
    selector_category_suv: 'BODY_TYPE',
    selector_category_transporter: 'BODY_TYPE',
    selector_category_van: 'BODY_TYPE',
    // Body Color
    selector_exteriorColor_beige: 'BODY_COLOR',
    selector_exteriorColor_black: 'BODY_COLOR',
    selector_exteriorColor_blue: 'BODY_COLOR',
    selector_exteriorColor_bronze: 'BODY_COLOR',
    selector_exteriorColor_brown: 'BODY_COLOR',
    selector_exteriorColor_gold: 'BODY_COLOR',
    selector_exteriorColor_green: 'BODY_COLOR',
    selector_exteriorColor_grey: 'BODY_COLOR',
    selector_exteriorColor_orange: 'BODY_COLOR',
    selector_exteriorColor_purple: 'BODY_COLOR',
    selector_exteriorColor_rainbow: 'BODY_COLOR',
    selector_exteriorColor_red: 'BODY_COLOR',
    selector_exteriorColor_silver: 'BODY_COLOR',
    selector_exteriorColor_white: 'BODY_COLOR',
    selector_exteriorColor_yellow: 'BODY_COLOR',
    // INTERIOR COLOR
    selector_interiorColor_beige: 'INTERIOR_COLOR',
    selector_interiorColor_black: 'INTERIOR_COLOR',
    selector_interiorColor_brown: 'INTERIOR_COLOR',
    selector_interiorColor_grey: 'INTERIOR_COLOR',
    selector_interiorColor_rainbow: 'INTERIOR_COLOR',
    // INTERIOR TYPE
    selector_interiorType_fabric: 'INTERIOR_TYPE',
    selector_interiorType_fullLeather: 'INTERIOR_TYPE',
    selector_interiorType_other: 'INTERIOR_TYPE',
    selector_interiorType_partLeather: 'INTERIOR_TYPE',
    selector_interiorType_velours: 'INTERIOR_TYPE',
    selector_interiorType_syntheticLeather: 'INTERIOR_TYPE',
    selector_interiorType_alcantara: 'INTERIOR_TYPE',
    // AIRBAG
    selector_airbag_airBelt: 'AIRBAG', // deprecated
    selector_airbag_beltAirbag: 'AIRBAG',
    selector_airbag_knee: 'AIRBAG', // deprecated
    selector_airbag_kneeAirbag: 'AIRBAG',
    selector_airbag_driver: 'AIRBAG',
    selector_airbag_front: 'AIRBAG',
    selector_airbag_frontAndSide: 'AIRBAG',
    selector_airbag_frontSideAndOther: 'AIRBAG',
    selector_airbag_head: 'AIRBAG',
    selector_airbag_motorcycle: 'AIRBAG',
    selector_airbag_passenger: 'AIRBAG',
    selector_airbag_pedestrian: 'AIRBAG',
    selector_airbag_rear: 'AIRBAG',
    selector_airbag_rearSeat: 'AIRBAG',
    selector_airbag_seatCushion: 'AIRBAG',
    // ASSISTANTS
    assistants_driveStartAssistant: 'ASSISTANTS',
    assistants_hillStartDrivingAssistant: 'ASSISTANTS',
    assistants_tirednessDetection: 'ASSISTANTS',
    assistants_nightVisionAssistant: 'ASSISTANTS',
    assistants_shiftPointDetection: 'ASSISTANTS',
    assistants_adaptiveCruiseControl: 'ASSISTANTS',
    assistants_speedLimiter: 'ASSISTANTS',
    assistants_powerAssistedSteering: 'ASSISTANTS',
    assistants_ebs: 'ASSISTANTS',
    assistants_distanceWarning: 'ASSISTANTS',
    assistants_parkingSensors: 'ASSISTANTS',
    assistants_tirePressureMonitor: 'ASSISTANTS',
    assistants_laneAssistant: 'ASSISTANTS',
    assistants_blindSpotDetection: 'ASSISTANTS',
    assistants_tractionControlSystem: 'ASSISTANTS',
    // PARKING_ASSISTANTS
    selector_parkingAssistants_360Camera: 'PARKING_ASSISTANTS',
    selector_parkingAssistants_camera: 'PARKING_ASSISTANTS',
    selector_parkingAssistants_front: 'PARKING_ASSISTANTS',
    selector_parkingAssistants_rear: 'PARKING_ASSISTANTS',
    selector_parkingAssistants_selfSteeringSystems: 'PARKING_ASSISTANTS',
    selector_parkingAssistants_other: 'PARKING_ASSISTANTS',
    // THEFT_PROTECTION
    theftProtection_alarmSystem: 'THEFT_PROTECTION',
    theftProtection_immobilizer: 'THEFT_PROTECTION',
    // CLIMATISATION
    selector_climatisation_no_airCondition: 'CLIMATISATION',
    selector_climatisation_airCondition: 'CLIMATISATION',
    selector_climatisation_automaticAirCondition: 'CLIMATISATION',
    selector_climatisation_2_automaticAirCondition: 'CLIMATISATION',
    selector_climatisation_3_automaticAirCondition: 'CLIMATISATION',
    selector_climatisation_4_automaticAirCondition: 'CLIMATISATION',
    selector_climatisation_5_automaticAirCondition: 'CLIMATISATION',
    // SEATS_OPTIONS
    seats_middleSeatingArrangement: 'SEATS_OPTIONS',
    seats_middleSeatingArrangementBack: 'SEATS_OPTIONS',
    // WHEEL
    wheel_adjustableSteeringWheel: 'WHEEL',
    wheel_leatherSteeringWheel: 'WHEEL',
    wheel_heatedSteeringWheel: 'WHEEL',
    wheel_shiftPadlle: 'WHEEL',
    // MULTIMEDIA 
    multimedia_wifiHotspot: 'MULTIMEDIA',
    multimedia_usbInterface: 'MULTIMEDIA',
    multimedia_auxiliaryAudioInput: 'MULTIMEDIA',
    multimedia_carplay: 'MULTIMEDIA',
    multimedia_androidAuto: 'MULTIMEDIA',
    multimedia_digitalCockpit: 'MULTIMEDIA',
    multimedia_onBoardComputer: 'MULTIMEDIA',
    multimedia_cdPlayer: 'MULTIMEDIA',
    multimedia_cdMultichanger: 'MULTIMEDIA',
    multimedia_rearSeatEntertainment: 'MULTIMEDIA',
    multimedia_smartphoneWirelessCharging: 'MULTIMEDIA',
    multimedia_mp3Interface: 'MULTIMEDIA',
    multimedia_sdCardReader: 'MULTIMEDIA',
    multimedia_voiceControl: 'MULTIMEDIA',
    multimedia_radioTuner: 'MULTIMEDIA',
    multimedia_radioDAB: 'MULTIMEDIA',
    multimedia_soundSystem: 'MULTIMEDIA',
    multimedia_integratedMusicStreaming: 'MULTIMEDIA',
    multimedia_tv: 'MULTIMEDIA',
    multimedia_touchscreen: 'MULTIMEDIA',
    // LIGHTS
    lights: 'LIGHTS',
    lights_daytimeRunningLights: 'LIGHTS',
    lights_daytimeRunningLightsLED: 'LIGHTS',
    lights_biXenonHeadlights: 'LIGHTS',
    lights_biLEDHeadlights: 'LIGHTS',
    lights_bendingLights: 'LIGHTS',
    lights_glareFreeHighBeam: 'LIGHTS',
    lights_longDistanceLightAssistant: 'LIGHTS',
    lights_frontFogLights: 'LIGHTS',
    lights_headlightCleaner: 'LIGHTS',
    lights_commingLeavingHome: 'LIGHTS',
    lights_ambienteLighting: 'LIGHTS',
    lights_adaptiveBendingLights: 'LIGHTS',
    // DOORS_OPTIONS
    doors_slidingDoorBothSides: 'DOORS_OPTIONS',
    doors_slidingDoorRight: 'DOORS_OPTIONS',
    doors_slidingDoorLeft: 'DOORS_OPTIONS',
    doors_electricSlidingDoor: 'DOORS_OPTIONS',
    doors_electricTailGate: 'DOORS_OPTIONS',
    doors_softCloseAutimatic: 'DOORS_OPTIONS',
    doors_centralLocking: 'DOORS_OPTIONS',
    doors_keylessEntry: 'DOORS_OPTIONS',
    // WINDOW_OPTIONS
    window_sunroof: 'WINDOW_OPTIONS',
    window_electricWindows: 'WINDOW_OPTIONS',
    window_heatedFrontWindow: 'WINDOW_OPTIONS',
    window_heatedWindshieldWasherSystem: 'WINDOW_OPTIONS',
    window_tintedWindowBack: 'WINDOW_OPTIONS',
    window_panoramaFrontWindow: 'WINDOW_OPTIONS',
    window_backRollerBlind: 'WINDOW_OPTIONS',
    window_sideRollerBlind: 'WINDOW_OPTIONS',
    window_rearWindowHeater: 'WINDOW_OPTIONS',
    window_rearWindowWiper: 'WINDOW_OPTIONS',
    window_ventWindows: 'WINDOW_OPTIONS',
    // MIRRORS_OPTIONS
    mirrors_electricExteriorMirrors: 'MIRRORS_OPTIONS',
    mirrors_heatedOutsideMirror: 'MIRRORS_OPTIONS',
    mirrors_integratedTurnSignalMirrors: 'MIRRORS_OPTIONS',
    mirrors_automaticReversMirrorDimmingOutside: 'MIRRORS_OPTIONS',
    mirrors_automaticReversMirrorDimmingInside: 'MIRRORS_OPTIONS',
    mirrors_driverVanityMirror: 'MIRRORS_OPTIONS',
    // LANDING_GEAR
    driveSuspension_axles: 'LANDING_GEAR',
    driveSuspension_selfLockingDifferential: 'LANDING_GEAR',
    driveSuspension_adaptiveChassis: 'LANDING_GEAR',
    driveSuspension_airSuspension: 'LANDING_GEAR',
    driveSuspension_airSuspensionAdaptive: 'LANDING_GEAR',
    driveSuspension_sportChassis: 'LANDING_GEAR',
    driveSuspension_roughRoadSuspension: 'LANDING_GEAR',
    driveSuspension_bss: 'LANDING_GEAR',
    // EXTRAS_OPTIONS
    extras_ureaTankAdBlue: 'EXTRAS_OPTIONS',
    extras_fasteningLoopsInTrunk: 'EXTRAS_OPTIONS',
    extras_roofBars: 'EXTRAS_OPTIONS',
    extras_roofRails: 'EXTRAS_OPTIONS',
    extras_hardtop: 'EXTRAS_OPTIONS',
    extras_coldstore: 'EXTRAS_OPTIONS',
    extras_disabledAccessible: 'EXTRAS_OPTIONS',
    extras_disabledConversion: 'EXTRAS_OPTIONS',
    extras_skiBag: 'EXTRAS_OPTIONS',
    extras_solarEnergySystem: 'EXTRAS_OPTIONS',
    extras_cargoBarrier: 'EXTRAS_OPTIONS',
    extras_divider: 'EXTRAS_OPTIONS',
    extras_centralLubricantApplication: 'EXTRAS_OPTIONS',
    extras_awning: 'EXTRAS_OPTIONS',
    extras_box: 'EXTRAS_OPTIONS',
    extras_bunkBed: 'EXTRAS_OPTIONS',
    extras_cabin: 'EXTRAS_OPTIONS',
    extras_electricStarter: 'EXTRAS_OPTIONS',
    extras_electricParkBreak: 'EXTRAS_OPTIONS',
    extras_universalGarageDoorOpener: 'EXTRAS_OPTIONS',
    extras_electricTop: 'EXTRAS_OPTIONS',
    extras_windshield: 'EXTRAS_OPTIONS',
    extras_discBrake: 'EXTRAS_OPTIONS',
    extras_rollOverBar: 'EXTRAS_OPTIONS',
    editionsPackages_sportPackage: 'EXTRAS_OPTIONS',
    editionsPackages_winterPackage: 'EXTRAS_OPTIONS',
    editionsPackages_smokersPackage: 'EXTRAS_OPTIONS',
    mainData_taxi: 'EXTRAS_OPTIONS',
    // DRIVER SEATS
    selector_driverSeats_seatVentilationSystem: 'DRIVER_SEATS',
    selector_driverSeats_electricAdjustable: 'DRIVER_SEATS',
    selector_driverSeats_electricHeated: 'DRIVER_SEATS',
    selector_driverSeats_electricAdjustableSeatsWithMemory: 'DRIVER_SEATS',
    selector_driverSeats_lumbarSupport: 'DRIVER_SEATS',
    selector_driverSeats_sleepFunction: 'DRIVER_SEATS',
    selector_driverSeats_withMassage: 'DRIVER_SEATS',
    selector_driverSeats_foldingFunction: 'DRIVER_SEATS',
    selector_driverSeats_sportSeats: 'DRIVER_SEATS',
    // CO DRIVER SEATS
    selector_coDriverSeats_electricHeated: 'CO_DRIVER_SEATS',
    selector_coDriverSeats_seatVentilationSystem: 'CO_DRIVER_SEATS',
    selector_coDriverSeats_electricAdjustable: 'CO_DRIVER_SEATS',
    selector_coDriverSeats_electricAdjustableSeatsWithMemory: 'CO_DRIVER_SEATS',
    selector_coDriverSeats_withMassage: 'CO_DRIVER_SEATS',
    selector_coDriverSeats_lumbarSupport: 'CO_DRIVER_SEATS',
    selector_coDriverSeats_sleepFunction: 'CO_DRIVER_SEATS',
    selector_coDriverSeats_foldingFunction: 'CO_DRIVER_SEATS',
    selector_coDriverSeats_sportSeats: 'CO_DRIVER_SEATS',
    selector_coDriverSeats_isofix: 'CO_DRIVER_SEATS',
    // BACK SEATS
    selector_backSeats_electricHeated: 'BACK_SEATS',
    selector_backSeats_seatVentilationSystem: 'BACK_SEATS',
    selector_backSeats_electricAdjustable: 'BACK_SEATS',
    selector_backSeats_electricAdjustableSeatsWithMemory: 'BACK_SEATS',
    selector_backSeats_withMassage: 'BACK_SEATS',
    selector_backSeats_lumbarSupport: 'BACK_SEATS',
    selector_backSeats_sleepFunction: 'BACK_SEATS',
    selector_backSeats_foldingFunction: 'BACK_SEATS',
    selector_backSeats_splitFolding: 'BACK_SEATS',
    selector_backSeats_isofix: 'BACK_SEATS'
};
